import { render, staticRenderFns } from "./Eliminaciones.vue?vue&type=template&id=3105a394&scoped=true"
import script from "./Eliminaciones.vue?vue&type=script&lang=js"
export * from "./Eliminaciones.vue?vue&type=script&lang=js"
import style0 from "./Eliminaciones.vue?vue&type=style&index=0&id=3105a394&prod&scoped=true&lang=css"
import style1 from "../main.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3105a394",
  null
  
)

export default component.exports